import { withCloseAfterExited } from "../modal";
import {
  default as View,
  UnsuspendUserModalProps
} from "./unsuspend-user-modal-view";

const UnsuspendUserModal = withCloseAfterExited<UnsuspendUserModalProps>(View);
export default UnsuspendUserModal;
